import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonListComponent } from './button-list.component';

@NgModule({
	exports: [ButtonListComponent],
	declarations: [ButtonListComponent],
	imports: [CommonModule],
})
export class ButtonListModule {}
